import clsx from 'clsx';
import Paragraph from 'components/universal/paragraph';
import React, { FC } from 'react';
import cls from './question.module.scss';

interface IProps {
    questionNumber?: number;
    title: string;
    answers: { [key: string]: string };
    checkedAnswers: string[];
    correctAnswers?: string[];
    isChecked?: boolean;
    setAnswers?: (answerId) => void;
    className?: string;
    prefix?: string | number;
    description: string | undefined;
    isQuiz: boolean;
}

export const Question: FC<IProps> = ({
    questionNumber,
    title,
    answers,
    checkedAnswers,
    correctAnswers,
    isChecked,
    setAnswers,
    className,
    prefix,
    description,
    isQuiz
}) => {
    const clsWrapper = clsx(cls.wrapper, {
        [className]: Boolean(className),
    });
    
    const sortedAnswers = React.useMemo(() => {
        const entries = Object.entries(answers);

        const sorted = entries.sort(([idA, a], [idB, b]) => {
            const lowerA = a.toLowerCase();
            const lowerB = b.toLowerCase();

            if (lowerA.includes('żadne z powyższych')) return 1;
            if (lowerB.includes('żadne z powyższych')) return -1;

            if (lowerA.includes('oba działania')) return 1;
            if (lowerB.includes('oba działania')) return -1;

            if (lowerA.includes('żaden z powyższych')) return 1;
            if (lowerB.includes('żaden z powyższych')) return -1;

            if (lowerA.includes('wszystkie z powyższych')) return 1;
            if (lowerB.includes('wszystkie z powyższych')) return -1;

            return 0;
        });

        return Object.fromEntries(sorted);
    }, [answers]);

    return (
        <div className={`${clsWrapper} question_wrapper`}>
            <div className={cls.headingWrapper}>
                {questionNumber && (
                    <Paragraph className={cls.bullet}>
                        {questionNumber}
                    </Paragraph>
                )}

                {isQuiz && <Paragraph className={cls.quizQuestion} fontWeight={700}>
                    {prefix && <span className={cls.bulletQuiz}>{prefix} </span>}
                    <span>{title}</span>
                </Paragraph>}

                {!isQuiz && <Paragraph fontWeight={700}>
                    {prefix && <span className={cls.blueText}>{prefix}: </span>}
                    {title}
                </Paragraph>}

                {description && 
                    <Paragraph className={cls.description}>
                        {description}
                    </Paragraph>
                }
            </div>
            <ul>
                {sortedAnswers &&
                    Object?.entries?.(sortedAnswers)?.map?.(([id, answer]) => (
                        <li
                            key={id}
                            className={clsx(cls.answer, {
                                [cls.answerChecked]:
                                    checkedAnswers?.includes?.(id),
                                [cls.answerError]:
                                    isChecked &&
                                    correctAnswers &&
                                    checkedAnswers?.includes?.(id) &&
                                    !correctAnswers?.includes?.(id),
                                [cls.answerCorrect]:
                                    isChecked &&
                                    correctAnswers?.includes?.(id) &&
                                    checkedAnswers?.includes?.(id),
                            })}
                        >
                            <button
                                className={cls.button}
                                onClick={() => setAnswers(id)}
                                disabled={isChecked}
                            >
                                <Paragraph className={cls.answerText}>
                                    {answer}
                                </Paragraph>
                            </button>
                        </li>
                    ))}
            </ul>
        </div>
    );
};
